<template>
  <v-card v-if="hasAdditionalInfo" width="100%" flat color="transparent">
    <!-- For breakpoints of md and up -->
    <v-row class="hidden-sm-and-down" justify="center" align="center">
      <v-col cols="11" class="mt-n6">
        <v-card color="primary" class="elevation-6" tile>
          <v-card-text class="px-3 py-2">
            <h3
              class="primary-font-color homepageSubTitle text-h6 font-weight-bold text-break"
            >
              {{ partnerGroupInfo.AdditionalInfoTitle }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- For breakpoints of sm and down -->
    <v-card-title class="hidden-md-and-up pb-2">
      <h2 class="text-break homepageTitle">
        {{ partnerGroupInfo.AdditionalInfoTitle }}
      </h2>
    </v-card-title>
    <v-card-text v-html="additionalInfo" />
  </v-card>
</template>

<script>
import utility from '@/shared/utility';

export default {
  name: 'AdditionalInfo',
  computed: {
    hasAdditionalInfo() {
      return (
        this.partnerGroupInfo != null &&
        this.partnerGroupInfo.AdditionalInfo !== '' &&
        this.partnerGroupInfo.AdditionalInfoTitle !== ''
      );
    },
    partnerGroupInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    additionalInfo() {
      if (this.partnerGroupInfo == null) {
        return '';
      }

      return utility.lineBreaksToHtml(this.partnerGroupInfo.AdditionalInfo);
    },
  },
};
</script>
